// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d7462fcb","453":"12c0df00","512":"8fb3dbf1"}[chunkId] + ".chunk.js";
};